import { formatDateRelative } from '@nucleus/lib-datetime';
import { PostWeb } from '@nucleus/types/web/posts/post';
import { PostIndexDocumentWeb } from '@nucleus/web-hosting';
import { format, parseISO } from 'date-fns';

export const formatPostDate = (post?: PostWeb | PostIndexDocumentWeb, relative?: boolean): string => {
  if (post?.date === undefined) {
    return '';
  }

  // Post dates have a time component that doesn't matter
  const [date] = post.date.split('Z');

  if (relative) {
    return formatDateRelative(date);
  }

  return format(parseISO(date), 'MMMM d, yyyy');
};
